import pl from "@locales/sales_products/pl.json";
import en from "@locales/sales_products/en.json";

export default { pl, en };
